// This is the JSON way to define React Router rules in a Rekit app.
// Learn more from: http://rekit.js.org/docs/routing.html

import {
  DefaultPage,
  ContactUs,
  PrivacyPolicy,
  TermsAndConditions,
  About,
  Press,
  Partners,
  OurInvestors,
  TravelAgency
} from './';
// import { About } from './About';
// import  Partners  from './Partners';
// import Press from './Press';

export default {
  path: '',
  name: 'Pages',
  childRoutes: [
    { path: 'es/pages/default-page', name: 'Default page', component: DefaultPage, isIndex: true },
    { path: 'es/pages/contact', name: 'Contact us', component: ContactUs },
    { path: 'es/pages/privacy-policy', name: 'Privacy policy', component: PrivacyPolicy },
    { path: 'es/pages/tnc', name: 'Terms and conditions', component: TermsAndConditions },
    { path: 'es/pages/about', name: 'About kupos.cl', component: About },
    { path: 'es/pages/partners', name: 'Our Partners', component: Partners },
    { path: 'es/pages/press', name: 'Press', component: Press },
    { path: 'es/pages/our-investors', name: 'Our Investors', component: OurInvestors },
    { path: 'es/pages/travel-agency', name: 'Travel Agency', component: TravelAgency },


    { path: 'en/pages/default-page', name: 'Default page', component: DefaultPage, isIndex: true },
    { path: 'en/pages/contact', name: 'Contact us', component: ContactUs },
    { path: 'en/pages/privacy-policy', name: 'Privacy policy', component: PrivacyPolicy },
    { path: 'en/pages/tnc', name: 'Terms and conditions', component: TermsAndConditions },
    { path: 'en/pages/about', name: 'About kupos.cl', component: About },
    { path: 'en/pages/partners', name: 'Our Partners', component: Partners },
    { path: 'en/pages/press', name: 'Press', component: Press },
    { path: 'en/pages/our-investors', name: 'Our Investors', component: OurInvestors },
    { path: 'en/pages/travel-agency', name: 'Travel Agency', component: TravelAgency },
  ],
};



// WEBPACK FOOTER //
// ./src/features/pages/route.js